<template>
    <layout-default>
        <div class="page-not-found">
            <div class="container h-100">
                <div class="main-content">
                    <img src="/images/404.png" alt="">
                    <h3>Oh oh… algo salío mal</h3>
                    <p>Lo sentimos, no pudimos encontrar la página que necesitabas</p>

                    <div class="row justify-content-center">
                        <div class="col-md-3 col-8">
                            <router-link :to="{name: 'Landing'}" class="btn-pdv-primary w-100">VOLVER AL INICIO</router-link>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </layout-default>
</template>

<script>
    import LayoutDefault from "@/layouts/Default"
    export default {


        components:{
            LayoutDefault
        }
    }
</script>

<style scoped lang="scss">
    .page-not-found{
        text-align: center;
        padding-top: 95px;
        height: 100vh;
        .main-content{
            position: relative;
            top: 50%;
            transform: translateY(-50%);

            img{
                width: 300px;
                @include media-breakpoint-down(sm){
                    width: 80%;
                }
            }
            h3{
                font-size: 38px;
                @include alternative-medium-regular;
                margin-bottom: 10px;

                @include media-breakpoint-down(sm){
                    font-size: 24px;
                    line-height: 28px;
                }
            }
            p{
                font-size: 20px;
                line-height: 24px;
                @include alternative-light-regular;
                margin-bottom: 24px;

                @include media-breakpoint-down(sm){
                    line-height: 22px;
                    font-size: 18px;
                }
            }
        }

    }
</style>